import React, { useMemo } from 'react';
import { BsBoxArrowLeft, BsChevronExpand } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
  Icon,
  IconButton,
  Link as ChakraLink,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Portal,
  Text
} from '@chakra-ui/react';
import userflow from 'userflow.js';

import { analyticsIds } from '../../../constants/analyticsIds';
import { CypressIds } from '../../../constants/cypressIds';
import { selectCompanyId } from '../../../redux/modules/company';
import { selectCompaniesListLoading, selectUserCompanies } from '../../../redux/modules/user';
import { queryClient } from '../../../utils/queryClientUtil';

const doTrackerResets = () => {
  window.heap.resetIdentity();
  userflow.reset();

  queryClient.clear();
};

const UserCompaniesDropdown = () => {
  const currentCompanyId = useSelector(selectCompanyId);
  const companies = useSelector(selectUserCompanies);
  const companiesLoading = useSelector(selectCompaniesListLoading);

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        data-cy={CypressIds.headerUserCompaniesDropdown}
        dusk="header-user-companies-and-logout-action-dropdown"
        icon={<Icon as={BsChevronExpand} boxSize="18px" />}
        variant="unstyled"
      />
      <Portal>
        <MenuList p={2}>
          <MenuGroup
            bg="greyScale.200"
            m={0}
            p={3}
          >
            {companiesLoading
              ? (<MenuItem borderRadius="md">Loading...</MenuItem>)
              : (
                <>
                  {companies
                    .filter(c => c.companyId !== currentCompanyId)
                    .map(company => (
                      <NavLink
                        key={company.companyId}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        to="#"
                        onClick={() => window.location.replace(`/v2/companies/${company.companyId}/departments`)}
                      >
                        <MenuItem
                          borderRadius="md"
                          dusk={`header-user-companies-and-logout-action-dropdown_company-${company.companyId}`}
                        >
                          {company.companyName}
                        </MenuItem>
                      </NavLink>
                    ))}
                </>
              )}
          </MenuGroup>
          <ChakraLink _hover={{ textDecor: 'none', color: 'inherit' }} href="/logout">
            <MenuItem
              data-analytics-id={analyticsIds.header.headerLogoutButton}
              data-cy={CypressIds.logoutButton}
              dusk={analyticsIds.header.headerLogoutButton}
              icon={<Icon as={BsBoxArrowLeft} boxSize="15px" />}
              onClick={() => doTrackerResets()}
            >
              Logout
            </MenuItem>
          </ChakraLink>
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default UserCompaniesDropdown;
